import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';

const container = document.getElementById('app');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);

const authChannel = new BroadcastChannel('auth');
authChannel.onmessage = event => {
  if (event.data === 'logout') {
    window.location.href = '/login';
  }
};

root.render(<App />);
